import { IAddress } from '@/types';

function convertAddressToStringForGeocoding(address: IAddress): string {
  if (!address) {
    return '';
  }
  return [
    address?.buildingNumber,
    address?.street,
    address?.city,
    address?.stateOrProvince,
    address?.postalCode, // Включаємо поштовий індекс
    address?.country,
  ]
    .filter(Boolean)
    .join(', ');
}

export default convertAddressToStringForGeocoding;
